<template>
    <div v-show="isModalVisible">
        <transition name="slide">
            <div class="modal-mask" @click="close">
                <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop>
                    <div class="modal-content">
                        <div class="modal-header">
                             <a href="javascript:void(0);" @click="hide" style="cursor: pointer;" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hide">
                                    <span aria-hidden="true">×</span>
                                </button>          
                        </div>                

                        <div class="modal-body">
                          <div class="row">
                            <div class="col-7">
                              <div class="maheading_2">
                                <h5 class="modal-title">Process Payment</h5>
                              </div>  
                            </div>
                            <div class="col-5 text-right">
                              &nbsp;
                            </div>
                          </div>
                          <div class="mt-3 mb-3 py-2 px-3 subscription_box rounded shadow">

                          <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-6">
                                    <span><label class="form-label">Invoice #:</label></span>
                                    
                                    </div>
                                    <div class="col-2">
                                    <label class="form-label text-center" style="width: 100%;">Due Date:</label>
                                    </div>
                                    <div class="col-4">
                                    <label class="form-label text-center" style="width: 100%;">Amount Due:</label>
                                    </div>
                                </div>
                                <div class="row row_data_border" >
                                    <div class="col-6">
                                    <label for="subscription_plan">{{ invoiceNo }}</label>
                                    </div>
                                    <div class="col-2 text-center">
                                    <label for="subscription_plan">{{ dueDate }}</label>
                                    </div>

                                <div class="col-4">
                                    <label for=""  style="width: 100%; text-align: center;"><span class="dollarsign" >$</span>&nbsp;{{ price }}</label>
                                </div>
                                </div>

                                <div class="row">
                                    <div class="col-9 col-sm-9"></div>
                                    <div class="col-3 col-sm-3" style="text-align: right; padding-right: 45px;">
                                    <button type="button" class="btn btn-sm btn-blue totalBtn text-center">
                                        Total: <span class="total_price">${{ subscriptionTotal }}</span>
                                    </button>
                                    </div>
                                </div>

                            </div>
                          </div>
                          </div>

                          <div class="mt-3 mb-3 py-2 px-3 subscription_box rounded shadow" >
                            <div class="row">
                                <div class="col-8">
                                  Payment Method
                                </div>
                                <div class="col-4 text-right pr-4">
                                    &nbsp;
                                </div>
                            </div>
                            <div class="row pb-2" v-if="cardName != ''">
                              <div class="col-3 seat_qty pt-1">
                                  {{ cardName }}
                              </div>
                              <div class="col-4  pt-1">
                                  {{ cardNo }}
                              </div>
                              <div class="col-2 pt-1">
                                  {{ cardExpire }}
                              </div>
                              <div class="col-3 text-right pr-2">
                                  <button type="submit" class="btn btn-md ma-blue-btn" @click="openPaymentListsModal">Edit</button>
                              </div>
                            </div>
                            <div class="row pb-2" v-else>
                              <div class="col-12 seat_qty text-center">
                                <i>No Payment Method found!</i>
                              </div>
                              <div class="col-12 text-center pt-2">
                                <button type="submit" class="btn btn-md ma-blue-btn" @click="openNewPaymentMethodModal()">Add New Payment Method</button>
                              </div>
                            </div>
                            <div class="clear"></div>
                          </div>




                        <div class="text-center m-4">
                            <button :disabled="disable_process_payment" type="button" class="btn btn-sm btn-blue saveBtn text-center" @click="processPayment">
                                Process Payment
                            </button>
                        </div>

                        <div class="my-5" style="height: 10px;"></div>
                        </div>
                        <div class="modal-footer"></div>
                    </div>
                </div>
            </div>
        </transition>

        <NewPaymentMethod
          :isModalVisible="isNewPaymentMethodModalVisible"
          ref="NewPaymentMethodModal"
          @close="isNewPaymentMethodModalVisible = false">
        </NewPaymentMethod>

        <PaymentLists
          :isModalVisible="isPaymentListsModalVisible"
          ref="PaymentListsModal"
          @close="isPaymentListsModalVisible = false">
        </PaymentLists>

        <AddLicenseSuccessModal 
            :isAddLicenseSuccessModalVisible="isAddLicenseSuccessModalVisible"
            :paymentMethod="paymentMethod"
            :invoice_filename="invoice_filename"            
            :unitType="unitType"
            landingPage="adminconsole"
            ref="add_license_success"
            @close="close"
        />

        <AddLicenseFailedModal
            :isAddLicenseFailedModalVisible="isAddLicenseFailedModalVisible"
            :unitType="unitType"
            landingPage="managelicense"
            @close="close"
        />

        <CreateInvoiceConfirmModal
            :isCreateInvoiceModalVisible="isCreateInvoiceModalVisible"
            landingPage="managelicense"            
            @close="close"
        />
        
    </div>
  </div>

</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import moment from 'moment';

import AddLicenseSuccessModal from './add_license_success_modal.vue';
import AddLicenseFailedModal from './add_license_failed_modal.vue';
import CreateInvoiceConfirmModal from './create_invoice_confirm_modal.vue';

import NewPaymentMethod from './new_payment_method.vue';
import PaymentLists from './payment_method_lists.vue';


Vue.filter('formatExpirationDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalVisible'],
    data() {
        return {
            loading: false,
            subscriptions: [],
            subscriptionId: '',
            subscription_plan: '',
            billingName: '',
            billingAddress: '',
            billingAddress2: '',
            billingCity: '',
            billingState: '',
            billingCountry: '',
            billingZip: '',
            billingPhone: '',
            nameOnCard: '',
            cardNumber: '',
            expMonth: '',
            expYear: '',
            cvvValue: '',
            year_options: [],
            subscriptionTotal: 0,
            isAccessPlan: 1,
            newAccountId: '',
            invoice_filename: '',
            close_url: '',
            country_options: [],
            state_options: [],
            isAddLicenseSuccessModalVisible: false,
            isCCRequired: 1,
            paymentMethod: 'credit_card',
            isAddLicenseFailedModalVisible: false,
            isCreateInvoiceModalVisible: false,
            activeLicense: 0,
            licenseType: '',
            invoiceNo: '',
            dueDate: '',
            price: 0,
            disable_process_payment: false,
            billing_name: '',
            billing_address: '',
            billing_address2: '',
            billing_city: '',
            billing_state: '',
            billing_country: '',
            billing_zip: '',
            billing_phone: '',
            payment_method: 'credit_card',
            invoice_filename: '',
            isNewPaymentMethodModalVisible: false,
            isPaymentListsModalVisible: false,
            cardName: '',
            cardNo: '',
            cardExpire: '',
            unitType: 'Seat',
            type: '',
        }
    },
    components: {
      AddLicenseSuccessModal,
      AddLicenseFailedModal,
      CreateInvoiceConfirmModal,        
      NewPaymentMethod,
      PaymentLists,
    },
    methods: {       
        hide() {
            this.$parent.closeProcessPaymentModal();
        },

        openNewPaymentMethodModal() {
          this.isNewPaymentMethodModalVisible = true;
          this.$refs.NewPaymentMethodModal.loadInitialData();
        },
        openPaymentListsModal() {
          this.isPaymentListsModalVisible = true;
          this.$refs.PaymentListsModal.loadInitialData();
        },
        closePaymentMethod() {
          this.isNewPaymentMethodModalVisible = false;
          this.getPrimaryPaymentDetails();
        },
        closePaymentMethodLists() { 
          this.isPaymentListsModalVisible = false;
          this.getPrimaryPaymentDetails();
        },
        getPrimaryPaymentDetails() {

          axios('/desktop/get-payment-details/'+ this.$store.state.user_accountid,
          {
            method: 'GET'        
          })
          .then(resp => {        
            this.cardName = resp.data.cardName;
            if(this.cardName == '') {
              this.disable_process_payment = true;
            }
            else {
              this.disable_process_payment = false;
            }
            this.cardNo = resp.data.cardNo;
            this.cardExpire = resp.data.cardExpire;
            this.billing_name = resp.data.billing_name;
            this.billing_address = resp.data.billing_address;
            this.billing_address2 = resp.data.billing_address2;
            this.billing_city = resp.data.billing_city;
            this.billing_state = resp.data.billing_state;
            this.billing_country = resp.data.billing_country;
            this.billing_zip = resp.data.billing_zip;
            this.billing_phone = resp.data.billing_phone;
          })
          .catch(() => {
          });      

        },

        setSubscriptionTotal(item) {
            this.subscriptionId = item.id;
            this.subscriptionTotal = item.price;
        },
        onSubmit() {
            this.$validator.validateAll().then((result) => {
                if (this.verrors.items.length === 0) {
                    this.processPayment();
                }
                
            });
        },
        processPayment() {
            this.disable_process_payment = true;
            this.loading = true;
            axios('/process-payment-orders', 
            {
                method: 'POST',
                data: {
                        "order_id": this.orderId,
                        "type": this.type,
                        "unitType": this.unitType,
                        "subscription_total": this.subscriptionTotal,
                        "account_id": this.$store.state.user_accountid,
                        "billing_name": this.billing_name,
                        "billing_address": this.billing_address,
                        "billing_address2": this.billing_address2,
                        "billing_city": this.billing_city,
                        "billing_state": this.billing_state,
                        "billing_country": this.billing_country,
                        "billing_zip": this.billing_zip,
                        "billing_phone": this.billing_phone,
                        "payment_method": this.paymentMethod,
                },
            })
            .then((response) => {
                this.disable_process_payment = false;
                this.loading = false;
                this.verrors.clear();
                this.invoice_filename = response.data.invoice_filename;
                if (response.data.msg != 'failed') {
                    this.isAddLicenseSuccessModalVisible = true;
                } else {
                    this.isAddLicenseFailedModalVisible = true;
                }
            })
            .catch(error => {
                this.disable_process_payment = false;
                console.log(error)
            });
        },
        getOrderDetailsLists(orderId) {
            axios.get('/get-process-payment-order-details/' + orderId)
            .then((resp) => {
                this.orderId = orderId;
                this.loading = false;
                this.invoiceNo = resp.data.invoiceNo;
                this.dueDate = resp.data.dueDate;
                this.price = resp.data.price;
                this.subscriptionTotal = resp.data.price;
                this.unitType = resp.data.unitType;
                this.type = resp.data.billingType;
            })
            .catch(error => {

            });
        },
        loadInitialData(orderId) {
            this.orderId = orderId;
            this.verrors.clear();
            this.getOrderDetailsLists(orderId);
            this.getPrimaryPaymentDetails();
        },
        getNoRecordText(count) {
            if (this.loading) {
                return '';
            } else {
                if (count == 0) {
                    return 'No Renew Subscription';
                }
            }
        },
        close() {
            this.verrors.clear();
            if (this.close_url) {
                let routeData = this.$router.resolve({name: this.close_url});
                window.open(routeData.href, '_self');
            } else {
                let routeData = this.$router.resolve({name: 'adminconsole'});              
                window.open(routeData.href, '_self');                
            }
        },
        choosePaymentMode(event) {
            if(event.target.value == 'credit_card') {
                this.isCCRequired = 1;
            }
            else {
                this.isCCRequired = 0;                
            }
        },
        onClose() {
          this.popoverShow = false
        },
    },
    created() {
    }   
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-body { padding: 0rem 1.5rem 0rem 1.5rem; overflow: auto;}
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.saveBtn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: auto;
  padding: 5px 20px;
}
.totalBtn, .totalBtn.btn-blue {
  color: #707070; 
  background-color: #FFF !important;
  border: 1px solid #707070 !important;
  border-radius: 10px;
  font-weight: 900;
  width: auto;
  padding: 8px;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  background-color: #efefef;
  min-height: 32px;
}
.ma-input-field:focus-visible {
  outline: none;
}
.form-label { font-size: 13px; font-weight: 900; } 
.row_data_border { padding: 5px 0; margin-bottom: 5px; font-size: 14px;border-bottom: 2px solid rgba(0, 0, 0, 0.1); }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.total_price { color: #00acee; }
.custom-select { height: 34px; }
.license-term-content { font-size: 12px;}
.license-term-label { color: #00ACEE; font-weight: bold; font-size: 13px; padding-top: 10px;}
.help-txt {
    display: inline-block;
    height: 15px;
    width: 15px;
    line-height: 15px;
    -moz-border-radius: 8px;
    border-radius:8px;
    border: 1px solid #00ACEE;
    background-color: white;
    color: #00ACEE;
    text-align: center;
    font-size: 0.75em;
    cursor: pointer;
}
.btn-secondary:hover { background-color: #FFF !important;}
.back_icon { width: 14px; }
.ma-blue-payment-btn {
  color: #FFF !important; 
  border-radius: 10px;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;  
  padding: 4px 15px 4px 15px;
}
.seat_qty {
    font-size: 13px;
}
.ma-blue-btn, .ma-blue-btn:hover, .ma-blue-btn:focus {
  color: #FFF !important; 
  border-radius: 15px;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  padding: 5px 20px;
}
.rounded {
    border-radius: 10px !important;
    padding: 20px;
    border: 1px solid #B8B7B8;
}

</style>
<style>
.popover-body { padding-right: 50px !important;}
.popover-header div { text-align: center;}
button.close { font-size: 30px;margin-top: -7px;}
.popover .popover-header { font-size: 14px; font-weight: bold;}
.popover { width: 340px !important; max-width: 340px !important;}
.bs-popover-right > .arrow::before {
    border-right-color: rgba(0, 172, 238, 0.90) !important;
}

</style>


// WEBPACK FOOTER //
// src/components/manager/process_payment.vue